import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function LooksOneIcon(props: IconProps) {
    return <Icon {...props} iconKey={"looks_one"}/>
}
